"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyState = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _Background = require("./Background.js");
var _Icon = require("./Icon.js");
var _IconContainer = require("./IconContainer.js");
var _MessageContainer = require("./MessageContainer.js");
var _excluded = ["background", "children", "icon", "iconTitle", "iconId", "iconColorSet", "variant", "maxInlineSize"];
/**
 * EmptyState is used when no other content or information is available.
 * It tells the user what they can expect to find there in the future and suggests a next step.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate--docs) |
 * [Encore site](https://encore.spotify.net/web/components/empty-state) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyState) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=9280-1056&t=uvnU5TzlyKmXuODT-1)
 */
var EmptyState = exports.EmptyState = function EmptyState(_ref) {
  var background = _ref.background,
    children = _ref.children,
    icon = _ref.icon,
    iconTitle = _ref.iconTitle,
    iconId = _ref.iconId,
    _ref$iconColorSet = _ref.iconColorSet,
    iconColorSet = _ref$iconColorSet === void 0 ? 'announcement' : _ref$iconColorSet,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'fullscreen' : _ref$variant,
    _ref$maxInlineSize = _ref.maxInlineSize,
    maxInlineSize = _ref$maxInlineSize === void 0 ? '400px' : _ref$maxInlineSize,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Background.Background, Object.assign({
    $background: background,
    $variant: variant
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.EmptyState
  }), /*#__PURE__*/_react["default"].createElement(_MessageContainer.MessageContainer, {
    $background: background,
    $variant: variant,
    $maxInlineSize: maxInlineSize
  }, icon && /*#__PURE__*/_react["default"].createElement(_IconContainer.IconContainer, {
    className: (0, _index.addColorSet)(iconColorSet)
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    icon: icon,
    title: iconTitle,
    titleId: iconId
  })), children));
};